import { render, staticRenderFns } from "./BusDataSyncDocMainSetModal.vue?vue&type=template&id=670c855e&scoped=true&"
import script from "./BusDataSyncDocMainSetModal.vue?vue&type=script&lang=js&"
export * from "./BusDataSyncDocMainSetModal.vue?vue&type=script&lang=js&"
import style1 from "./BusDataSyncDocMainSetModal.vue?vue&type=style&index=1&id=670c855e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670c855e",
  null
  
)

export default component.exports